export default "__VITE_ASSET__BNR71roF__"